import { createSelector } from 'reselect';
import { isImmutableMap } from 'EmailData/types/immutable';
const getPortalTrialStatus = state => {
  return isImmutableMap(state) ? state.get('portalTrialStatus') : state.portalTrialStatus;
};
const getTrials = createSelector([getPortalTrialStatus], portalTrialStatus => {
  return portalTrialStatus.portalTrials.map(({
    trial
  }) => trial);
});
const getMarketingEmailTrial = createSelector([getTrials], trials => trials.find(trial => {
  var _trial$name;
  return trial === null || trial === void 0 || (_trial$name = trial.name) === null || _trial$name === void 0 ? void 0 : _trial$name.includes('marketing');
}));
export const getHasMarketingEmailTrial = createSelector([getMarketingEmailTrial], marketingEmailTrial => !!marketingEmailTrial);
export const getMarketingEmailTrialType = createSelector([getMarketingEmailTrial], marketingEmailTrial => {
  var _marketingEmailTrial$;
  return (_marketingEmailTrial$ = marketingEmailTrial === null || marketingEmailTrial === void 0 ? void 0 : marketingEmailTrial.name) !== null && _marketingEmailTrial$ !== void 0 ? _marketingEmailTrial$ : false;
});